export default {
  pagarme: {
    encryptionKey: process.env.REACT_APP_PagarMeEncryptionKey,
  },
}
